import {IMailingState} from "./MailingState";
import { IMailing } from "../models/mailing";
import { MailingStatus } from "../models/enums/MailingStatus";
import { SearchRecipientsType } from "../models/enums/SearchRecipientsType";
import { MailingType } from "../models/enums/MailingType";
import { IBotStartParams } from "../models/BotStartParams";
import { SendingType } from "../../mailing-main/mailing-list/mailing-item-info/CreateMailingInfo/~types/enums/SendingType";

export const initMailing = () : IMailing  =>  { 
    return{
        mailingId: 0,
        allBots: [],
        name: "",
        createdOn: new Date(),
        modifiedOn: new Date(),
        status: MailingStatus.pending,
        mailingType: MailingType.message,
        text: "",
        buttonText: "",
        buttonUrl: "",
        recipients: [],
        isEmergency: false,
        sendingType: SendingType.SendToLastMessenger,
        channelsIds: [],
        searchRecipientsType: SearchRecipientsType.inContacts,
        searchingTagsForChats: [],
        searchingTagsForContacts: [],
        botStartParams: {} as IBotStartParams
    }
}

export const initState: IMailingState = {
    mailingList: {
        isReceivingmailings: false,
        allMailings: []
    },
    mailingItemInfo: {
        mailing: initMailing(),
        newMailing: initMailing(),
        recipients: [],
        enabledChannels: []
    }
}